.centerText {
    padding-bottom: 10px;
    text-align: center;
}